import downloadjs from 'downloadjs'
import { fetchWithToken } from '@hublot-io/core-api/client'
import config from '../utils/apiUtils'

export const RemarquesService = {
  getAllRemarques(clientId) {
    return fetchWithToken(`${config().remarquesService}/${clientId}`, { method: 'GET' })
      .then((response) => response.json())
  },
  downloadAll(data) {
    return fetchWithToken(`${config().pdfService}`, {
      method: 'POST',
      body: JSON.stringify({
        data,
        url: `${document.location.origin}/remarque.html`,
      }),
    }).then((response) => response.blob())
      .then((file) => {
        downloadjs(file, `${data.title}.pdf`)
      })
  },
}
